export default __webpack_public_path__ + "static/media/Ballroll_00160.720405fa.png";